import React from 'react'
import Loader from './Loader'

function About() {
  return (
    
    <div className="about wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6">
                    <div className="about-img">
                        <img src="img/residence1.jpeg" alt="Image"/>
                    </div>
                </div>
                <div className="col-lg-7 col-md-6">
                    <div className="section-header text-left">
                        <p>Welcome to Saara Constructions</p>
                        <h2>20 Years Experience</h2>
                    </div>
                    <div className="about-text">
                        <p>
                       Saara Constructions co is a trusted and rapidly growing construction company dedicated to delivering high-quality residential, commercial, and industrial projects. With a strong focus on engineering excellence, modern design, and customer satisfaction, we transform ideas into durable, beautiful, and functional structures.


                        </p>
                        <p>
                        For years, we have been known for precision workmanship, on-time delivery, and transparent project management. Our team of experienced engineers, architects, and skilled professionals ensure that every project we build meets the highest standards of safety, quality, and long-term durability.
                        </p>
                        <a className="btn" href="">Learn More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  )
}

export default About
